import {ModuleTopic} from '@cp/model';
import {env} from '../../../config/env';

/**
 * Map a module topic to a topic id
 * @param moduleTopic - The module topic to map
 * @returns The topic id (category|topic)
 */
export default function mapModuleTopicToTopicId(moduleTopic: ModuleTopic): string {
  return [moduleTopic.category, moduleTopic.topic].join(env.topic.spacer);
}
